(function () {
  function initReviewsWidget(container) {
    var tabs = container.querySelectorAll('.ReviewsWidget__tab');
    var cards = container.querySelectorAll('.ReviewsWidget__card');

    if (!tabs.length) return;

    function activate(selectedTab) {
      var category = selectedTab.getAttribute('data-category');

      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab === selectedTab);
      });

      cards.forEach(function (card) {
        var match = card.getAttribute('data-category') === category;
        card.classList.toggle('is-hidden', !match);
      });

      requestAnimationFrame(function () {
        setupReadMore(container);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab);
      });
    });

    activate(tabs[0]);
  }

  function setupReadMore(container) {
    var cards = container.querySelectorAll('.ReviewsWidget__card:not(.is-hidden)');

    cards.forEach(function (card) {
      var textEl = card.querySelector('.ReviewsWidget__card-text');
      if (!textEl) return;

      var btn = card.querySelector('.ReviewsWidget__read-more');

      if (!textEl.dataset.fullHeight) {
        textEl.style.maxHeight = 'none';
        textEl.style.overflow = 'visible';
        textEl.dataset.fullHeight = textEl.scrollHeight;
      }

      var lineHeight = parseFloat(getComputedStyle(textEl).lineHeight);
      var clampHeight = Math.ceil(lineHeight * 3);
      var fullHeight = parseInt(textEl.dataset.fullHeight, 10);
      var needsClamp = fullHeight > clampHeight + 2;

      if (needsClamp) {
        if (!btn) {
          textEl.style.maxHeight = clampHeight + 'px';
          textEl.style.overflow = 'hidden';

          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'ReviewsWidget__read-more';
          btn.textContent = 'Read more';
          textEl.insertAdjacentElement('afterend', btn);

          btn.addEventListener('click', function () {
            var isExpanded = textEl.style.maxHeight !== clampHeight + 'px';
            if (isExpanded) {
              textEl.style.maxHeight = clampHeight + 'px';
              textEl.style.overflow = 'hidden';
              btn.textContent = 'Read more';
            } else {
              textEl.style.maxHeight = fullHeight + 'px';
              textEl.style.overflow = 'visible';
              btn.textContent = 'Read less';
            }
          });
        }
      } else {
        textEl.style.maxHeight = 'none';
        textEl.style.overflow = 'visible';
        if (btn) btn.remove();
      }
    });
  }

  function boot() {
    document.querySelectorAll('.ReviewsWidget').forEach(initReviewsWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var widget = e.target.querySelector('.ReviewsWidget');
      if (widget) initReviewsWidget(widget);
    });
  }
})();
